
import { EditorState, Modifier } from 'draft-js';
import { linkifyit } from 'linkify-it';
import tlds from 'tlds';

const linkify = linkifyit().tlds(tlds);

const findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();

        return (
            entityKey !== null &&
            contentState.getEntity(entityKey).getType() === 'LINK'
        );
    }, callback);
};

const Link = (props) => {
    const { contentState, entityKey, children } = props;

    const { url, target = '_blank' } = contentState.getEntity(entityKey).getData();

    return (
        <a href={url} target={target} rel="noopener noreferrer">
            {children}
        </a>
    );
};

const pasteLinkPlugin = (config = {}) => {
    const { target = '_blank' } = config;

    return {
        decorators: [{
            strategy: findLinkEntities,
            component: Link,
        }],
        handlePastedText: (text, html, editorState, pluginFunctions) => {
            const links = linkify.match(text);

            if (!links || links.length === 0) {
                return 'not-handled';
            }

            const selection = editorState.getSelection();
            const contentState = editorState.getCurrentContent();

            // Create an entity for each detected URL.
            let contentWithEntities = contentState;
            const entityRanges = [];

            links.forEach(({ url, index, lastIndex }) => {
                contentWithEntities = contentWithEntities.createEntity('LINK', 'MUTABLE', { url, target });

                entityRanges.push({
                    start: index,
                    end: lastIndex,
                    key: contentWithEntities.getLastCreatedEntityKey(),
                });
            });

            // Insert all pasted text without assigning a link entity.
            let newContent = Modifier.replaceText(
                contentWithEntities,
                selection,
                text,
                editorState.getCurrentInlineStyle()
            );

            const selectionAfterInsert = newContent.getSelectionAfter();

            // Apply each entity only to its corresponding URL.
            const blockKey = selection.getStartKey();
            const startOffset = selection.getStartOffset();

            entityRanges.forEach(({ start, end, key }) => {
                const linkSelection = selection.merge({
                    anchorKey: blockKey,
                    focusKey: blockKey,
                    anchorOffset: startOffset + start,
                    focusOffset: startOffset + end,
                    isBackward: false,
                });

                newContent = Modifier.applyEntity(
                    newContent,
                    linkSelection,
                    key
                );
            });

            const newEditorState = EditorState.push(
                editorState,
                newContent,
                'insert-characters'
            );

            pluginFunctions.setEditorState(
                EditorState.forceSelection(
                    newEditorState,
                    selectionAfterInsert
                )
            );

            return 'handled';
        },
    };
};

export default pasteLinkPlugin;
